import HTTP from "../../utility/http";
import { asyncHandler } from "@/utility/async";
const clone = require("lodash/cloneDeep");

const state = {
  riverSections: [],
};

const getters = {
  getRiverSections: (state) => clone(state.riverSections),
};

const actions = {
  async all({ commit }, data) {
    const resp = await asyncHandler(
      HTTP({ url: "river_section/all/" + data.withDeleted, method: "GET" })
    );
    if (resp.success) {
      commit("set_riverSections", resp.river_sections);
    }
    return resp;
  },

  async save_riverSection(context, data) {
    let url, method;
    if (data.id) {
      url = "river_section/" + data.id;
      method = "PUT";
    } else {
      url = "river_section";
      method = "POST";
    }
    delete data.id;
    return await asyncHandler(HTTP({ url, method, data }));
  },

  async delete_riverSection(context, data) {
    return asyncHandler(
      HTTP({ url: "river_section/" + data.id, method: "DELETE" })
    );
  },

  async restore_riverSection(context, data) {
    return await asyncHandler(
      HTTP({ url: "river_section/restore/" + data.id, method: "GET" })
    );
  },
};

const mutations = {
  set_riverSections: (state, riverSections) => {
    state.riverSections = riverSections;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
